import MentoringNewRequestForm from './MentoringNewRequestForm.vue';

export * from './types';
export default MentoringNewRequestForm;



// WEBPACK FOOTER //
// ./src/pages/profile/modules/mentoring/requestform/index.ts